import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Typography,
    Fade,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import RefreshIcon from '@material-ui/icons/Refresh';
import OutlookStyleEmailView from './OutlookStyleEmailView';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: 0,
            backgroundColor: '#f3f2f1',
            maxWidth: '100%',
            width: '100%',
            height: '100%',
            margin: 0,
        },
    },
    dialogTitle: {
        backgroundColor: '#0078d4',
        color: '#ffffff',
        padding: theme.spacing(0.75, 2),
        minHeight: 40,
    },
    titleContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    titleLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    titleIcon: {
        fontSize: 20,
    },
    titleText: {
        fontSize: '0.9375rem',
        fontWeight: 500,
    },
    titleRight: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
    headerButton: {
        color: '#ffffff',
        padding: 6,
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
    dialogContent: {
        padding: 0,
        height: 'calc(100vh - 40px)',
        overflow: 'hidden',
    },
}));

const EmailThreadDialog = ({ open, onClose, consumerId }) => {
    const classes = useStyles();
    const { t } = useTranslation('overview');
    const [refreshKey, setRefreshKey] = useState(0);

    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
            className={classes.dialog}
        >
            <DialogTitle className={classes.dialogTitle} disableTypography>
                <Box className={classes.titleContent}>
                    <Box className={classes.titleLeft}>
                        <MailOutlineIcon className={classes.titleIcon} />
                        <Typography className={classes.titleText}>
                            {t('lblEmail2Case') || 'Email2Case'}
                        </Typography>
                    </Box>
                    <Box className={classes.titleRight}>
                        <IconButton
                            onClick={handleRefresh}
                            className={classes.headerButton}
                            size="small"
                            title="Yenile"
                        >
                            <RefreshIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            onClick={handleClose}
                            className={classes.headerButton}
                            size="small"
                            title="Kapat"
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <OutlookStyleEmailView
                    key={refreshKey}
                    consumerId={consumerId}
                    onClose={handleClose}
                />
            </DialogContent>
        </Dialog>
    );
};

export default EmailThreadDialog;
